import compact from 'lodash/compact';
import { DetailsBooking, Money } from 'types';
import { PaymentSummaryProps } from '../PaymentSummary';

export type Payments = ReturnType<typeof flattenTransactions>;

const flattenTransactions = ({ transactions }: DetailsBooking) => {
  return transactions.flatMap((transaction) => {
    const { chargeBreakdown, createdAt, type, reason } = transaction;
    const { points, creditCard, creditNote, qantasGroupCreditVoucher } = chargeBreakdown;
    const transactionDetails = { createdAt, type, reason };

    return compact([
      points.paymentMethod && {
        method: 'points',
        ...points.paymentMethod,
        ...transactionDetails,
        total: { amount: points.total, currency: 'PTS' } as Money,
      },
      creditCard.paymentMethod && {
        method: 'credit_card',
        ...creditCard.paymentMethod,
        ...transactionDetails,
        total: { amount: creditCard.total, currency: 'AUD' } as Money,
      },
      creditNote.paymentMethod && {
        method: 'credit_note',
        ...creditNote.paymentMethod,
        ...transactionDetails,
        total: { amount: creditNote.total, currency: 'AUD' } as Money,
      },
      qantasGroupCreditVoucher.paymentMethod && {
        method: 'qantas_group_credit_voucher',
        ...qantasGroupCreditVoucher.paymentMethod,
        ...transactionDetails,
        total: { amount: qantasGroupCreditVoucher.total, currency: 'AUD' } as Money,
      },
    ]);
  });
};

export const bookingToPaymentSummaryProps = (booking: DetailsBooking): PaymentSummaryProps => {
  const { paidBeforeCancellation } = booking;
  const transactionAmounts: Payments = flattenTransactions(booking);
  const paidToDateAmounts: Array<Money> = paidBeforeCancellation.totals as Array<Money>;

  return { transactionAmounts, paidToDateAmounts };
};
